import { Button, Flex, Table, message } from 'antd';

import {
	useAddVideoToCollection,
	useDeleteVideoFromCollection,
} from '@/api/monitor_collections';
import { IVideoCollectionItem } from '@/ts';

type TProps = {
	data: any;
	columns: any;
	onTableChange: any;
	isLoading: boolean;
	isFetching: boolean;
	pagination: any;
	setPagination: any;
	videoId: number;
};

export default function AddRemoveVideoCollectionsTable({
	data,
	columns,
	onTableChange,
	isLoading,
	isFetching,
	pagination,
	setPagination,
	videoId,
}: TProps) {
	const { mutate: addVideo, isLoading: isAddLoading } =
		useAddVideoToCollection();
	const { mutate: deleteVideo, isLoading: isDeleteLoading } =
		useDeleteVideoFromCollection();

	const onAddClick = (id: number) => {
		addVideo(
			{
				collection_id: id,
				post_id: videoId,
			},
			{
				onSuccess: () => {
					message.success('Added');
				},
				onError: (error) => {
					const err = error as any;
					message.error(
						`An error occured: ${
							err?.response?.data?.message || err?.message
						}.`,
					);
					console.error('error', error);
				},
			},
		);
	};

	const onDeleteClick = (id: number) => {
		deleteVideo(
			{
				collection_id: id,
				post_id: videoId,
			},
			{
				onSuccess: () => {
					message.success('Removed');
				},
				onError: (error) => {
					const err = error as any;
					message.error(
						`An error occured: ${
							err?.response?.data?.message || err?.message
						}.`,
					);
					console.error('error', error);
				},
			},
		);
	};

	return (
		<Table
			key={videoId}
			size="small"
			// dataSource={data?.data?.data?.results}
			dataSource={data}
			columns={[
				...columns,
				{
					title: 'Actions',
					// ellipsis: true,
					// hidden: withoutActions,
					width: 65,
					dataIndex: 'actions',
					key: 'actions',
					fixed: 'right',
					render: (_: any, record: IVideoCollectionItem) => {
						return (
							<Flex justify="center" align="center" style={{ gap: '4px' }}>
								{record?.video_list?.includes(videoId) ? (
									<Button
										size="small"
										style={{ minWidth: '60px' }}
										danger
										onClick={() => onDeleteClick(Number(record?.id))}
									>
										Remove
									</Button>
								) : (
									<Button
										size="small"
										style={{ minWidth: '60px' }}
										// type="primary"
										// variant="outlined"
										onClick={() => onAddClick(Number(record?.id))}
									>
										Add
									</Button>
								)}
							</Flex>
						);
					},
				},
			]}
			style={{ width: '100%' }}
			rowClassName="editable-row"
			rowKey={'id'}
			onChange={onTableChange}
			loading={isLoading || isFetching || isDeleteLoading || isAddLoading}
			bordered
			pagination={{
				total: pagination?.total,
				pageSize: pagination?.limit,
				current: pagination?.page,
				// pageSizeOptions: [5, 10],
				onChange: (page: number, pageSize: number) => {
					setPagination((cur: any) => ({ ...cur, page, limit: pageSize }));
				},
			}}
		/>
	);
}
